import clsx from "clsx";
import React from "react";

const PublicTag = ({ isPublic }: { isPublic: boolean }) => {
  return (
    <div className="flex items-center gap-[5px]">
      <span className={clsx(isPublic ? "bg-attention" : "bg-form-border", "h-[10px] w-[10px] rounded-full")} />
      <span className={clsx("text-sm", isPublic ? "text-black" : "text-disabled")}>{isPublic ? "公開" : "非公開"}</span>
    </div>
  );
};

export default PublicTag;
